var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRickshaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1797_14821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 56H33.25V52.5L45.5 59.5H36.75V63L24.5 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4999 31.675V25.725C59.4999 24.92 59.2199 24.15 58.7299 23.555L46.5499 8.33C45.8849 7.49 44.8699 7 43.8199 7L24.4999 7.7C22.5749 7.7 1.3999 22.575 1.3999 24.5V38.5C1.3999 40.425 2.9749 42 4.8999 42L10.6749 42C11.4799 45.99 15.0149 49 19.2499 49C23.4849 49 27.0199 45.99 27.8249 42H49.1749C50.1549 46.83 55.0899 50.19 60.4449 48.615C63.1399 47.81 65.3099 45.64 66.1149 42.945C67.6899 37.59 64.3299 32.655 59.4999 31.675ZM19.2499 45.5C16.3449 45.5 13.9999 43.155 13.9999 40.25C13.9999 37.345 16.3449 35 19.2499 35C22.1549 35 24.4999 37.345 24.4999 40.25C24.4999 43.155 22.1549 45.5 19.2499 45.5ZM24.4999 24.5H1.3999L4.43616 23.1L5.42368 22.0869L7.82673 19.8867L12.9251 15.6577L18.4454 11.4487L21.3015 9.44509L22.9474 8.4L24.4999 7.7C24.4999 6.72 24.4999 10.5 24.4999 10.5V24.5ZM41.9999 38.5H27.9999V28H33.2499C34.2299 28 34.9999 27.23 34.9999 26.25C34.9999 25.27 34.2299 24.5 33.2499 24.5H27.9999V10.5H40.2499C41.2299 10.5 41.9999 11.27 41.9999 12.25V38.5ZM45.4999 24.5V12.6L55.0199 24.5H45.4999ZM57.7499 45.5C54.8449 45.5 52.4999 43.155 52.4999 40.25C52.4999 37.345 54.8449 35 57.7499 35C60.6549 35 62.9999 37.345 62.9999 40.25C62.9999 43.155 60.6549 45.5 57.7499 45.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.3999,
    y: 7,
    width: 23.8,
    height: 18.2,
    fill: "#086972"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1797_14821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRickshaw);
export default __webpack_public_path__ + "static/media/Rickshaw.d1753c48eda0b88b8911ba285b09d1b1.svg";
export { ForwardRef as ReactComponent };